import React, { useEffect, useState } from 'react'

import { isMobile } from 'react-device-detect'
import { useLocation, useNavigate } from 'react-router-dom'
import useGetMePlan from 'hooks/query/useGetMePlan'

import { UsageRequestFactor } from 'service/list'
import useGetUsageRequest from 'hooks/query/useGetUsageRequest'

import { showYoutubeAuth, UserType } from 'utils/common'
import { GuideToUse } from 'components/GuideToUse'
import classNames from 'classnames'

import { PromotionCircle } from 'components/upgrade/PromotionCircle'
import useGetShortUsageRequest from 'hooks/query/useGetShortUsageRequest'
import { ShortsVideoDailyBarChart } from 'components/chart/DailyBarChart'

import { Modal } from 'components/layout/Modal'
import { TextAreaMyVideo } from 'components/atom/TextArea'
import { Controller, useForm } from 'react-hook-form'

import {
  EmptyPlan,
  FreePlan,
  LightPlan,
  ProAndPremiumPlanAnnual,
  ProAndPremiumPlanMonthly,
} from 'components/PlanDashBoard/PlanDashBoard'
import useCreateChallenge from 'hooks/query/challenge/useCreateChallenge'
import useGetChallenge from 'hooks/query/challenge/useGetChallenge'
import useUpdateChallenge from 'hooks/query/challenge/useUpdateChallenge'
import { ChallengeType } from 'service/challenge'
import useInsertLinkChallenge from 'hooks/query/challenge/useInsertLinkChallenge'
import { PlanPriceModal } from 'components/payment/PlanPriceModal'
import useUserStore from 'store/useUserStore'
import useGetTextContentRequest from 'hooks/query/useGetTextContentRequest'
import { FastclickDashBoard } from 'components/fastclick/FastclickDashBoard'
import { FastclickDescription } from 'components/fastclick/FastclickDescription'
import { AuthGuard } from 'components/gaurd/AuthGuard'
import { Helmet } from 'react-helmet-async'

import {
  VideoType,
  getVideoTypeDescription,
  getApiTypeByVideoType,
  getVideoTypeFromParam,
} from 'constant/videoTypes'
import { VideoGuideList } from './components/VideoGuideList'
import { subscriptionType } from 'service/plans'
import { useTranslation } from 'hooks/useTranslation'
import { UploadTiktokBtn } from 'pages/tiktok/UploadTiktokBtn'

export const VideoUsageHistory = () => {
  const { t } = useTranslation()
  const userInfo = useUserStore((state: any) => state.userInfo)
  const userAgent = navigator.userAgent.toLowerCase()

  const getStatusText = (status: string) => {
    switch (status) {
      case '생성 대기':
        return t('videoUsageHistory.status.waitingForGeneration')
      case '재시도':
        return t('videoUsageHistory.status.retry')
      case '생성 실패':
        return t('videoUsageHistory.status.generationFailed')
      case '생성 완료':
        return t('videoUsageHistory.status.generationCompleted')
      case '등록 완료':
        return t('videoUsageHistory.status.registrationCompleted')
      default:
        return status
    }
  }

  const location = useLocation()
  const navigate = useNavigate()
  const [totalItems, setTotalItems] = useState(0)
  const itemsPerPage = 10
  const [defaultPage, setDefaultPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const totalPages = Math.ceil(totalItems / itemsPerPage)

  const params = new URLSearchParams(location.search)
  const tType = params.get('type')
  let page = parseInt(params.get('page') || '', 10)

  const [tab, setTab] = useState(getVideoTypeFromParam(tType))
  const [dashboardTab, setDashboardTab] = useState(VideoType.PRODUCT_LONG)
  const [isPlanPriceModal, setPlanPriceModal] = useState<boolean>(false)
  const [linkSaveModal, setLinkSaveModal] = useState<boolean>(false)
  const [showRevenueModal, setShowRevenueModal] = useState<boolean>(false)
  const [failInfoModal, setFailInfoModal] = useState<boolean>(false)
  const [errorText, setErrorText] = useState({
    title: '',
    subtitle: <></>,
  })

  if (!page || isNaN(page) || page < 1) {
    page = defaultPage
    params.set('type', tab)
    params.set('page', page.toString())
    params.set('pageSize', itemsPerPage.toString())
    navigate({ search: params.toString() })
  }
  //* 패스트컷 비디오 사용량(상품 롱폼)
  const {
    data: usageRequest,
    refetch: usageRefetch,
    isError,
  } = useGetUsageRequest(page, itemsPerPage)

  //* 링크 / 상품 숏폼
  const {
    data: shortUsageRequest,
    refetch: shortUsageRefetch,
    isError: isShortError,
  } = useGetShortUsageRequest(page, itemsPerPage, getApiTypeByVideoType(tab))

  //* 텍스트 비디오
  const {
    data: textContentUsageRequest,
    refetch: textContentUsageRefetch,
    isError: isTextContentError,
  } = useGetTextContentRequest(page, itemsPerPage)

  const { data: userPlanInfo } = useGetMePlan()

  // user의 영상생성 개수 불러오기

  const [usageList, setUsageList] = useState<UsageRequestFactor[] | []>([])
  const openStatusDialog = (fcStatus: string) => {
    if (['재시도', '생성 실패'].includes(fcStatus)) {
      if (fcStatus === '생성 실패') {
        setErrorText({
          title: t('videoUsageHistory.errors.videoGenerationFailed'),
          subtitle: (
            <>
              {t('videoUsageHistory.errors.failureReasonPart1')}
              <br />
              {t('videoUsageHistory.errors.failureReasonPart2')}
              <br />
              {t('videoUsageHistory.errors.emailNotificationPart1')}
              <br />
              {t('videoUsageHistory.errors.emailNotificationPart2')}
              <br />
              {t('videoUsageHistory.errors.pleaseCheck')}
            </>
          ),
        })
      } else if (fcStatus === '재시도') {
        setErrorText({
          title: t('videoUsageHistory.errors.videoGenerationRetry'),
          subtitle: (
            <>
              {t('videoUsageHistory.errors.retryReasonPart1')}
              <br />
              {t('videoUsageHistory.errors.retryMessage')}
              <br />
              {t('videoUsageHistory.errors.retryTimeNotice')}
            </>
          ),
        })
      }

      setFailInfoModal((prev: any) => !prev)
    }
  }
  const createTable = () => {
    if (isMobile) {
      return (
        <>
          <div
            className="  rounded-b-[20px] md:rounded-tr-[20px]  md:py-[40px] md:px-8"
            style={{ border: '1px solid #EEF1F7' }}
          >
            <table className="min-w-full border-collapse py-4">
              <thead className="">
                <tr className="border-b text-center text-[#5E6068]">
                  <th className="w-[30px] px-2 py-5">
                    {t('videoUsageHistory.table.headers.no')}
                  </th>
                  <th className="px-2 py-5 text-left">
                    {t('videoUsageHistory.table.headers.title')}
                  </th>
                  <th className=" w-[79px] px-1 py-5">
                    {t('videoUsageHistory.table.headers.status')}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="text-center text-[#5E6068] bg-[#EBF4FF]">
                  <td className="text-[20px]">💁🏻</td>
                  <td className="text-[14px]">
                    {t('videoUsageHistory.messages.mobileDownloadNote')}
                    <br />
                    {t('videoUsageHistory.messages.mobileDownloadDescription')}
                  </td>
                  <td className="">
                    <a
                      className="flex gap-1 items-center bg-white rounded-full text-[12px] px-2 py-2 a"
                      href={
                        userAgent.includes('android')
                          ? 'https://play.google.com/store/apps/details?id=com.google.android.apps.docs&hl=ko'
                          : 'https://apps.apple.com/kr/app/google-%EB%93%9C%EB%9D%BC%EC%9D%B4%EB%B8%8C-%EC%95%88%[…]%8C%EC%9D%BC-%EC%A0%80%EC%9E%A5%EA%B3%B5%EA%B0%84/id507874739'
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src="assets/img/drive.png" alt="drive" />
                      {`앱 설치 >`}
                    </a>
                  </td>
                </tr>
                {usageList.length > 0 ? (
                  <>
                    {usageList.map((el, index) => {
                      const {
                        mainTitle,
                        createdAt: requestedAt,
                        contentCreatedAt,
                        uploadedAt,
                        driveLink,
                        type,
                        status,
                      } = el

                      return (
                        <>
                          <tr className="text-center text-[#5E6068]">
                            <td
                              className={`px-1  align-top ${
                                index === 0 ? 'py-[24px]' : 'pb-[24px]'
                              }`}
                            >
                              {totalItems &&
                                (totalItems - itemsPerPage * (page - 1) - index)
                                  .toString()
                                  .padStart(2, '0')}
                            </td>

                            <td
                              className={`px-1  align-top text-left ${
                                index === 0 ? 'py-[24px]' : 'pb-[24px]'
                              }`}
                            >
                              {mainTitle !== ''
                                ? mainTitle
                                : t(
                                    'videoUsageHistory.messages.videoGenerationPreparing'
                                  )}
                            </td>
                            <td
                              className={` flex items-start h-[24px] px-1  align-top text-left ${
                                index === 0 ? 'py-[24px]' : 'pb-[24px]'
                              }`}
                            >
                              <a
                                href={driveLink}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <button
                                  className={`text-[#FFFFFF] font-bold rounded-[20px] text-[12px] w-[79px] h-[24px] flex justify-center items-center gap-[4px]  ${
                                    driveLink && ' active:scale-95'
                                  } ${status === '생성 대기' && 'bg-[#C4DFFF]'}
                                  ${status === '재시도' && 'bg-[#FF8800]'}
                                  ${status === '생성 실패' && 'bg-[#2E343D]'}
                                  ${status === '생성 완료' && 'bg-[#3A8FF2]'}
                                  ${status === '등록 완료' && 'bg-[#464DEE]'} `}
                                  onClick={() => {
                                    openStatusDialog(status)
                                  }}
                                >
                                  <span>{getStatusText(status)} </span>{' '}
                                  {['재시도', '생성 실패'].includes(status) &&
                                    '>'}
                                  {driveLink && (
                                    <img
                                      src="assets/img/icon_cloud.png"
                                      alt="cloud"
                                      height={14}
                                      width={14}
                                    />
                                  )}
                                </button>
                              </a>
                            </td>
                          </tr>
                        </>
                      )
                    })}
                  </>
                ) : (
                  <>
                    {' '}
                    <tr>
                      <td
                        colSpan={6}
                        rowSpan={10}
                        className="text-center py-[80px]"
                      >
                        <p className="text-[18px] font-bold leading-[28px]">
                          {t('videoUsageHistory.noData.noRequestsYet')}{' '}
                          {tab === VideoType.PRODUCT_LONG ||
                          tab === VideoType.PRODUCT_SHORT
                            ? t('videoUsageHistory.noData.video')
                            : t('videoUsageHistory.noData.contentVideo')}
                          {t('videoUsageHistory.noData.notExist')}
                          <br />
                          {getVideoTypeDescription(tab, t)}
                          <br />
                          <span className="text-main">
                            <button
                              onClick={() => {
                                tab === VideoType.PRODUCT_LONG ||
                                tab === VideoType.PRODUCT_SHORT
                                  ? navigate('/video-editor')
                                  : navigate(
                                      `/short-video-editor?createType=${
                                        tab === VideoType.LINK_CONTENT
                                          ? 'link'
                                          : 'text'
                                      }`
                                    )
                              }}
                            >
                              {tab === VideoType.PRODUCT_LONG ||
                              tab === VideoType.PRODUCT_SHORT
                                ? t(
                                    'videoUsageHistory.noData.createProductVideoButton'
                                  )
                                : t(
                                    'videoUsageHistory.noData.createContentVideoButton'
                                  )}
                            </button>
                          </span>
                        </p>
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>
          <div className="pagenation flex justify-center gap-[4px] mt-3 ">
            <button
              className="flex items-center justify-center w-[32px] h-[32px] border-[1px] border-[#DFE3E8] font-bold text-[14px] disabled:bg-[#EEF1F7]"
              onClick={() => handlePageEndChange(1)}
              disabled={currentPage === 1}
            >
              <img src="assets/img/icon_arrow_left_end.png" alt="icon" />
            </button>
            <button
              className="flex items-center justify-center w-[32px] h-[32px] border-[1px] border-[#DFE3E8] font-bold text-[14px] disabled:bg-[#EEF1F7]"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <img src="assets/img/icon_arrow_left.png" alt="icon" />
            </button>
            {renderPageNumbers()}
            <button
              className="flex items-center justify-center w-[32px] h-[32px] border-[1px] border-[#DFE3E8] font-bold text-[14px] disabled:bg-[#EEF1F7]"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              <img src="assets/img/icon_arrow_right.png" alt="icon" />
            </button>
            <button
              className="flex items-center justify-center w-[32px] h-[32px] border-[1px] border-[#DFE3E8] font-bold text-[14px] disabled:bg-[#EEF1F7]"
              disabled={currentPage === totalPages}
              onClick={() => {
                handlePageEndChange(totalPages)
              }}
            >
              <img src="assets/img/icon_arrow_right_end.png" alt="icon" />
            </button>
          </div>
        </>
      )
    } else {
      return (
        <>
          <div
            className=" w-full md:rounded-b-[20px] md:rounded-tr-[20px]  md:py-[40px] md:px-8"
            style={{ border: '1px solid #EEF1F7' }}
          >
            <table className="min-w-full border-collapse">
              <thead className="">
                <tr className="border-b text-center text-[#5E6068]">
                  <th className="w-[30px] px-2 pb-5">
                    {t('videoUsageHistory.table.headers.no')}
                  </th>

                  <th className="px-2 pb-5 text-left">
                    {t('videoUsageHistory.table.headers.title')}
                  </th>
                  <th className=" w-[42px] px-1 pb-5">
                    {t('videoUsageHistory.table.headers.request')}
                  </th>
                  <th className=" w-[42px] px-1 pb-5">
                    {t('videoUsageHistory.table.headers.generation')}
                  </th>

                  <th className=" w-[42px] px-1 pb-5">
                    {t('videoUsageHistory.table.headers.registration')}
                  </th>

                  <th className=" w-[79px] px-1 pb-5">
                    {t('videoUsageHistory.table.headers.status')}
                  </th>
                  <th className=" w-[79px] px-1 pb-5">
                    {t('videoUsageHistory.table.headers.upload')}
                  </th>
                </tr>
              </thead>
              <tbody className="">
                {usageList?.length > 0 ? (
                  <>
                    {usageList.map((el, index) => {
                      const {
                        mainTitle,
                        createdAt: requestedAt,
                        uploadedAt,
                        contentCreatedAt,
                        driveLink,
                        type,
                        status,
                      } = el

                      return (
                        <>
                          <tr className="text-center text-[#5E6068]">
                            <td className="px-1  p-[12px]">
                              {totalItems &&
                                (totalItems - itemsPerPage * (page - 1) - index)
                                  .toString()
                                  .padStart(2, '0')}
                            </td>

                            <td className="px-1  p-[12px] text-left">
                              {mainTitle !== ''
                                ? mainTitle
                                : t(
                                    'videoUsageHistory.messages.videoGenerationPreparing'
                                  )}
                            </td>
                            <td className="request px-1 p-[12px]">
                              {requestedAt}
                            </td>
                            <td className="create px-1 p-[12px]">
                              {contentCreatedAt}
                            </td>

                            <td className="upload px-1   p-[12px]">
                              {uploadedAt}
                            </td>

                            <td className="h-[24px] px-1  p-[12px]">
                              <a
                                href={driveLink}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <button
                                  className={`flex items-center justify-center gap-[4px] text-[#FFFFFF] font-bold rounded-[20px] text-[12px] w-[79px] h-[24px]
                                  ${driveLink && ' active:scale-95'} ${
                                    status === '생성 대기' && 'bg-[#C4DFFF]'
                                  }
                                  ${status === '재시도' && 'bg-[#FF8800]'}
                                  ${status === '생성 실패' && 'bg-[#2E343D]'}
                                  ${
                                    status === '생성 완료' && 'bg-[#3A8FF2]'
                                  }  ${
                                    status === '등록 완료' && 'bg-[#464DEE]'
                                  } `}
                                  onClick={() => {
                                    openStatusDialog(status)
                                  }}
                                >
                                  <span>{getStatusText(status)}</span>{' '}
                                  {['재시도', '생성 실패'].includes(status) &&
                                    '>'}
                                  {driveLink && (
                                    <img
                                      src="assets/img/icon_cloud.png"
                                      alt="cloud"
                                      height={14}
                                      width={14}
                                    />
                                  )}
                                </button>
                              </a>
                            </td>
                            <td className="">
                              <div className="flex justify-center items-center h-full">
                                <UploadTiktokBtn />
                              </div>
                            </td>
                          </tr>
                        </>
                      )
                    })}
                  </>
                ) : (
                  <>
                    {' '}
                    <tr>
                      <td
                        colSpan={6}
                        rowSpan={10}
                        className="text-center py-[80px]"
                      >
                        <p className="text-[18px] font-bold leading-[28px]">
                          {t('videoUsageHistory.noData.noRequestsYet')}{' '}
                          {tab === VideoType.PRODUCT_LONG ||
                          tab === VideoType.PRODUCT_SHORT
                            ? t('videoUsageHistory.noData.video')
                            : t('videoUsageHistory.noData.contentVideo')}
                          {t('videoUsageHistory.noData.notExist')}
                          <br />
                          {getVideoTypeDescription(tab, t)}
                          <br />
                          <span className="text-main">
                            <button
                              onClick={() => {
                                tab === VideoType.PRODUCT_LONG ||
                                tab === VideoType.PRODUCT_SHORT
                                  ? navigate('/video-editor')
                                  : navigate(
                                      `/short-video-editor?createType=${
                                        tab === VideoType.LINK_CONTENT
                                          ? 'link'
                                          : 'text'
                                      }`
                                    )
                              }}
                            >
                              {tab === VideoType.PRODUCT_LONG ||
                              tab === VideoType.PRODUCT_SHORT
                                ? t(
                                    'videoUsageHistory.noData.createProductVideoButton'
                                  )
                                : t(
                                    'videoUsageHistory.noData.createContentVideoButton'
                                  )}
                            </button>
                          </span>
                        </p>
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
              {/* <div className="w-full">
               
              </div> */}
            </table>
            <div className=" pagenation flex justify-center gap-[4px] ">
              <button
                className="flex items-center justify-center w-[32px] h-[32px] border-[1px] border-[#DFE3E8] font-bold text-[14px] disabled:bg-[#EEF1F7]"
                onClick={() => handlePageEndChange(1)}
                disabled={currentPage === 1}
              >
                <img src="assets/img/icon_arrow_left_end.png" alt="icon" />
              </button>
              <button
                className="flex items-center justify-center w-[32px] h-[32px] border-[1px] border-[#DFE3E8] font-bold text-[14px] disabled:bg-[#EEF1F7]"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <img src="assets/img/icon_arrow_left.png" alt="icon" />
              </button>
              {renderPageNumbers()}
              <button
                className="flex items-center justify-center w-[32px] h-[32px] border-[1px] border-[#DFE3E8] font-bold text-[14px] disabled:bg-[#EEF1F7]"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <img src="assets/img/icon_arrow_right.png" alt="icon" />
              </button>
              <button
                className="flex items-center justify-center w-[32px] h-[32px] border-[1px] border-[#DFE3E8] font-bold text-[14px] disabled:bg-[#EEF1F7]"
                disabled={currentPage === totalPages}
                onClick={() => {
                  handlePageEndChange(totalPages)
                }}
              >
                <img src="assets/img/icon_arrow_right_end.png" alt="icon" />
              </button>
            </div>
          </div>
        </>
      )
    }
  }

  const renderPageNumbers = () => {
    const pagesPerBlock = 10
    const pageNumbers = []
    const currentBlock = Math.floor((currentPage - 1) / pagesPerBlock)
    const startPage = currentBlock * pagesPerBlock + 1
    const endPage = Math.min(startPage + pagesPerBlock - 1, totalPages)

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          className={classNames(
            `flex items-center justify-center w-[32px] h-[32px] border-[1px]  font-bold text-[14px]`,
            {
              'border-main text-main': currentPage === i,
              'border-[#DFE3E8]': currentPage !== i,
            }
          )}
          key={i}
          onClick={() => handlePageChange(i)}
          disabled={currentPage === i}
        >
          {i}
        </button>
      )
    }

    return pageNumbers
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
    const params = new URLSearchParams(location.search)
    params.set('page', page.toString())
    params.set('pageSize', itemsPerPage.toString())
    navigate({ search: params.toString() })
  }
  const handlePageEndChange = (page: number) => {
    setCurrentPage(page)
    const params = new URLSearchParams(location.search)
    params.set('page', page.toString())
    params.set('pageSize', itemsPerPage.toString())
    navigate({ search: params.toString() })
  }

  const handleTab = (type: VideoType) => {
    setTab(type)
  }
  const handleDashboardTab = (type: string) => {
    setDashboardTab(VideoType.PRODUCT_LONG)
  }

  const chartElByTab = () => {
    if (dashboardTab === VideoType.LINK_CONTENT) {
      return (
        <>
          <div className="flex flex-col w-full  p-5  bg-white rounded-[10px] justify-evenly h-[210px] md:w-[474px] relative">
            <p className="font-bold">2024. 11월</p>

            <ShortsVideoDailyBarChart barWidth={isMobile ? 4 : 8} />
            <div className="bg-white opacity-50 w-full h-full absolute"></div>
            <div className="bg-white border-[2px] border-[#D9DEE8] w-[87px] h-[37px] font-bold text-[14px] rounded-[8px] absolute left-[37.5%] md:left-[45%] top-[50%] flex items-center justify-center">
              <p className="text-center z-50">{t('common.loading')}</p>
            </div>
          </div>
          <div className="flex w-full md:w-[248px]  p-5 bg-white rounded-[20px] items-center justify-evenly">
            <div className="items flex flex-col items-center gap-2">
              <p
                className={classNames(
                  'bg-[#C4DFFF] flex items-center justify-center',
                  {
                    'w-[50px] h-[50px]  rounded-[100px] ':
                      userInfo?.fastCutShortUsageSummary[0]?.ready.length ??
                      0 < 3,
                    'w-[70px] h-[50px] rounded-[50px] ':
                      userInfo?.fastCutShortUsageSummary[0]?.ready.length >= 3,
                  }
                )}
              >
                <span className="text-white font-bold text-[24px]">
                  {userInfo?.fastCutShortUsageSummary[0]?.ready ?? 0}
                </span>
              </p>

              <p className="font-bold">
                {t('videoUsageHistory.status.waitingForGeneration')}
              </p>
            </div>
            <div className="items flex flex-col items-center gap-2">
              <p
                className={classNames(
                  'bg-[#3A8FF2]  flex items-center justify-center',
                  {
                    'w-[50px] h-[50px]  rounded-[100px] ':
                      userInfo?.fastCutShortUsageSummary[0]?.complete.length ??
                      0 < 3,
                    'w-[70px] h-[50px] rounded-[50px] ':
                      userInfo?.fastCutShortUsageSummary[0]?.complete.length >=
                      3,
                  }
                )}
              >
                <span className="text-white font-bold text-[24px]">
                  {' '}
                  {userInfo?.fastCutShortUsageSummary[0]?.complete ?? 0}
                </span>
              </p>
              <p className="font-bold">
                {t('videoUsageHistory.status.generationCompleted')}
              </p>
            </div>
          </div>
        </>
      )
    } else if (dashboardTab === VideoType.PRODUCT_LONG) {
      return (
        <>
          {userInfo?.userType === UserType.라이트 && (
            <>
              <LightPlan
                subscriptionType={
                  userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
                }
                startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
                endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
                currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
                subscriptions={userPlanInfo?.subscriptions}
                monthStart={userPlanInfo?.subscriptions.monthStart ?? '--'}
                monthEnd={userPlanInfo?.subscriptions.monthEnd ?? '--'}
              />
            </>
          )}
          {(userInfo?.userType === UserType.프로 ||
            userInfo?.userType === UserType.프리미엄 ||
            userInfo?.userType === UserType['숏폼 스페셜']) &&
          userInfo?.subscriptions?.subscriptionType === 'annual' ? (
            <>
              <ProAndPremiumPlanAnnual
                userType={userInfo?.userType}
                subscriptionType={
                  userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
                }
                startDate={userPlanInfo?.subscriptions?.monthStart ?? '--'}
                endDate={userPlanInfo?.subscriptions?.monthEnd ?? '--'}
                currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
                available={userPlanInfo?.usage?.available ?? false}
                couponBenefit={userInfo?.couponBenefit}
                isDone={userPlanInfo?.usage?.isDone}
                subscriptions={userPlanInfo?.subscriptions}
              />
            </>
          ) : (
            (userInfo?.userType === UserType.프로 ||
              userInfo?.userType === UserType.프리미엄 ||
              userInfo?.userType === UserType['숏폼 스페셜']) &&
            userInfo?.subscriptions?.subscriptionType === 'monthly' && (
              <>
                {' '}
                <ProAndPremiumPlanMonthly
                  userType={userInfo?.userType}
                  subscriptionType={
                    userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
                  }
                  startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
                  endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
                  currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
                  available={userPlanInfo?.usage?.available ?? false}
                  isDone={userPlanInfo?.usage?.isDone}
                  couponBenefit={userInfo?.couponBenefit}
                  subscriptions={userPlanInfo?.subscriptions}
                />
              </>
            )
          )}
          {userInfo?.userType === UserType.USER && (
            <>
              <EmptyPlan
                subscriptionType={
                  userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
                }
                startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
                endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
                currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
                setPlanPriceModal={setPlanPriceModal}
              />
            </>
          )}
          {userInfo?.userType === UserType.체험 && (
            <>
              <FreePlan
                userType={userInfo?.userType}
                subscriptionType={
                  userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
                }
                startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
                endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
                currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
                totalLimit={userPlanInfo?.usage?.totalLimit ?? 0}
                usedCount={userPlanInfo?.usage?.usedCount ?? 0}
                available={userPlanInfo?.usage?.available ?? false}
                couponBenefit={userInfo?.couponBenefit}
                isDone={userPlanInfo?.usage?.isDone}
                subscriptions={userPlanInfo?.subscriptions}
              />
            </>
          )}
        </>
      )
    } else {
      return null
    }
  }

  const handleChallengeBtn = () => {
    if (
      dashboardTab === VideoType.PRODUCT_LONG &&
      userInfo?.challenge &&
      userPlanInfo?.subscriptions?.round &&
      userInfo?.challenge?.status === 'active' &&
      (userPlanInfo?.subscriptions?.planId === 2 ||
        userPlanInfo?.subscriptions?.planId === 3) &&
      userPlanInfo?.subscriptions?.subscriptionType === subscriptionType.ANNUAL
    ) {
      if (userPlanInfo?.subscriptions?.round <= 3) {
        return (
          <div className="">
            <button
              className="bg-[#735CFF] flex gap-1 rounded-[20px] w-[343px] md:w-[156px] h-[36px] justify-center items-center font-bold text-[14px] text-[white]"
              onClick={() => {
                setLinkSaveModal((prev) => !prev)
              }}
            >
              <span>✋챌린지 참여 선언</span>
            </button>
          </div>
        )
      } else if (userPlanInfo?.subscriptions?.round > 3) {
        return (
          <div className="">
            <button
              className="bg-[#007A7B] flex gap-1 rounded-[20px] w-[343px] md:w-[116px] h-[36px] justify-center items-center font-bold text-[14px] text-[white]"
              onClick={() => {
                setShowRevenueModal((prev) => !prev)
              }}
            >
              <img src="assets/img/money.png" alt="" width={20} height={20} />
              <span>수익 인증</span>
            </button>
          </div>
        )
      }
    }
  }
  useEffect(() => {
    if (usageRequest && tab === VideoType.PRODUCT_LONG) {
      setUsageList(usageRequest.data)
      setTotalItems(usageRequest.totalCount)
    }
    if (isShortError && tab === VideoType.LINK_CONTENT) {
      setUsageList([])
      setTotalItems(0)
    }
    if (shortUsageRequest && tab === VideoType.LINK_CONTENT) {
      setUsageList(shortUsageRequest.data)
      setTotalItems(shortUsageRequest.totalCount)
    }
    if (isError && tab === VideoType.PRODUCT_LONG) {
      setUsageList([])
      setTotalItems(0)
    }
    if (shortUsageRequest && tab === VideoType.PRODUCT_SHORT) {
      setUsageList(shortUsageRequest.data)
      setTotalItems(shortUsageRequest.totalCount)
    }
    if (isShortError && tab === VideoType.PRODUCT_SHORT) {
      setUsageList([])
      setTotalItems(0)
    }
    if (textContentUsageRequest && tab === VideoType.TEXT_CONTENT) {
      setUsageList(textContentUsageRequest.data)
      setTotalItems(textContentUsageRequest.totalCount)
    }
    if (isTextContentError && tab === VideoType.TEXT_CONTENT) {
      setUsageList([])
      setTotalItems(0)
    }
  }, [usageRequest, shortUsageRequest, textContentUsageRequest, tab])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const page = parseInt(params.get('page') || '', 10)
    if (page && tab === VideoType.PRODUCT_LONG) {
      setCurrentPage(page)
      usageRefetch()
    } else if (page && tab === VideoType.LINK_CONTENT) {
      setCurrentPage(page)
      shortUsageRefetch()
    } else if (page && tab === VideoType.PRODUCT_SHORT) {
      setCurrentPage(page)
      shortUsageRefetch()
    } else if (page && tab === VideoType.TEXT_CONTENT) {
      setCurrentPage(page)
      textContentUsageRefetch()
    }
  }, [location.search])

  useEffect(() => {
    let page = 1
    params.set('type', tab)
    params.set('page', page.toString())
    params.set('pageSize', itemsPerPage.toString())
    navigate({ search: params.toString() })
  }, [tab])
  useEffect(() => {
    const userType = userInfo?.userType
    if (userType && userType === UserType['숏폼 스페셜']) {
      setTab(VideoType.PRODUCT_SHORT)
    }
  }, [userInfo])
  return (
    <>
      <Helmet>
        <title>{t('videoUsageHistory.title')}</title>
        <meta
          name="description"
          content="내가 생성 요청한 영상들의 진행 상태와 다운로드 가능 여부를 확인하세요."
        />
        <link
          rel="canonical"
          href="https://fastcut.fastseller.shop/my-videos"
        />
      </Helmet>
      <div className=" md:w-[816px] w-[375px] min-h-[100vh] my-0 mx-auto flex flex-col items-center px-4">
        <div className="md:w-[816px] w-[343px] flex flex-col gap-6 ">
          {/* {!isMobile && (
          <My>
            <p>사용 현황</p>
          </My>
        )} */}
          <div className="flex justify-center ">
            <p className="font-bold text-[24px] md:text-[40px]">
              {t('videoUsageHistory.title')}
            </p>
          </div>
          <div className="my-videos flex flex-col  md:w-[816px] w-[343px] tab ">
            <div className="flex md:flex-row  flex-col-reverse  text-[18px] items-end md:items-center ">
              <div className="flex mt-6 md:mt-0 w-full ">
                <button
                  className={classNames(
                    'md:w-[200px] w-[171.5px] h-[54px] flex items-center justify-center  rounded-t-[20px]',
                    {
                      'bg-[#F6F8FB]': dashboardTab === VideoType.PRODUCT_LONG,
                      'bg-[#EEF1F7] text-[#B6BBC6]':
                        dashboardTab !== VideoType.PRODUCT_LONG,
                    }
                  )}
                  onClick={() => {
                    handleDashboardTab(VideoType.PRODUCT_LONG)
                  }}
                >
                  <p className="font-bold ">상품 영상</p>
                </button>
                {/* <button
                className={classNames(
                  'md:w-[200px] w-[171.5px] h-[54px] flex items-center justify-center  rounded-tr-[20px]',
                  {
                    'bg-[#F6F8FB]': dashboardTab === VideoType.LINK_CONTENT,
                    'bg-[#EEF1F7] text-[#B6BBC6]':
                      dashboardTab !== LINK_CONTENT_VIDEO,
                  }
                )}
                onClick={() => {
                  handleDashboardTab(LINK_CONTENT_VIDEO)
                }}
              >
                <p className="font-bold ">컨텐츠 영상</p>
              </button> */}
              </div>
              <div className="flex flex-col md:flex-row md:ml-2 md:items-start md:justify-start items-center justify-center w-full  gap-[6px]">
                {handleChallengeBtn()}
                {dashboardTab === VideoType.PRODUCT_LONG && (
                  <>
                    {' '}
                    {showYoutubeAuth(
                      userInfo,
                      'flex justify-center items-center md:w-[248px] md:h-[36px] w-[343px] h-[46px] bg-error text-white font-bold text-[14px] rounded-[40px]'
                    )}
                  </>
                )}
                {dashboardTab === VideoType.PRODUCT_LONG && isMobile && (
                  <>
                    <PromotionCircle
                      userInfo={userInfo}
                      planId={userInfo?.subscriptionType?.planId}
                      classNameProps="w-full h-[46px]  rounded-full text-white font-bold"
                    />
                  </>
                )}
              </div>
            </div>

            <div
              className={classNames(
                'flex flex-col rounded-b-[20px] md:rounded-tr-[20px] bg-[#F6F8FB] md:px-10 md:py-8 p-[10px] md:w-full w-[343px] ',
                {
                  'rounded-tr -[20px]': isMobile,
                }
              )}
            >
              <div className="name mb-2 ">
                {userInfo?.userInfo?.name}
                {` `}({userInfo?.userInfo?.email}){` `}님
              </div>
              {/* <div className="  flex flex-col md:flex-row w-full gap-4 md:justify-between relative">
                {chartElByTab()}
              </div> */}
              <AuthGuard userInfo={userInfo}>
                <FastclickDashBoard userInfo={userInfo} blockWidth="w-full" />
              </AuthGuard>
            </div>
          </div>
          {dashboardTab === VideoType.PRODUCT_LONG && !isMobile && (
            <>
              <div className="flex justify-center">
                <PromotionCircle
                  userInfo={userInfo}
                  planId={userInfo?.subscriptionType?.planId}
                  classNameProps="w-full h-[46px]  rounded-full text-white font-bold"
                />
              </div>
            </>
          )}
          <div className="list flex flex-col w-full">
            <div className="flex mt-6 md:mt-0 md:text-base text-[14px] ">
              {userInfo?.userType !== UserType['숏폼 스페셜'] && (
                <button
                  className={classNames(
                    'md:w-[140px] w-[171.5px] h-[54px] flex items-center justify-center  rounded-tl-[20px]',
                    {
                      'border-t-[1px] border-l-[1px]':
                        tab === VideoType.PRODUCT_LONG,
                      'bg-[#EEF1F7] text-[#B6BBC6]':
                        tab !== VideoType.PRODUCT_LONG,
                    }
                  )}
                  onClick={() => {
                    handleTab(VideoType.PRODUCT_LONG)
                  }}
                >
                  <p className="font-bold ">
                    {t('videoUsageHistory.tabs.productLongForm')}
                  </p>
                </button>
              )}
              <button
                className={classNames(
                  'md:w-[140px] w-[171.5px] h-[54px] flex items-center justify-center  ',
                  {
                    'border-t-[1px] border-l-[1px]':
                      tab === VideoType.PRODUCT_SHORT,
                    'bg-[#EEF1F7] text-[#B6BBC6]':
                      tab !== VideoType.PRODUCT_SHORT,
                    'rounded-tl-[20px]':
                      userInfo?.userType === UserType['숏폼 스페셜'],
                  }
                )}
                onClick={() => {
                  handleTab(VideoType.PRODUCT_SHORT)
                }}
              >
                <p className="font-bold ">
                  {t('videoUsageHistory.tabs.productShortForm')}
                </p>
              </button>
              <button
                className={classNames(
                  'md:w-[140px] w-[171.5px] h-[54px] flex items-center justify-center ',
                  {
                    'border-t-[1px] border-r-[1px]':
                      tab === VideoType.LINK_CONTENT,
                    'bg-[#EEF1F7] text-[#B6BBC6]':
                      tab !== VideoType.LINK_CONTENT,
                  }
                )}
                onClick={() => {
                  handleTab(VideoType.LINK_CONTENT)
                }}
              >
                <p className="font-bold ">
                  {t('videoUsageHistory.tabs.linkContent')}
                </p>
              </button>
              <button
                className={classNames(
                  'md:w-[140px] w-[171.5px] h-[54px] flex items-center justify-center  rounded-tr-[20px]',
                  {
                    'border-t-[1px] border-r-[1px]':
                      tab === VideoType.TEXT_CONTENT,
                    'bg-[#EEF1F7] text-[#B6BBC6]':
                      tab !== VideoType.TEXT_CONTENT,
                  }
                )}
                onClick={() => {
                  handleTab(VideoType.TEXT_CONTENT)
                }}
              >
                <p className="font-bold ">
                  {t('videoUsageHistory.tabs.textContent')}
                </p>
              </button>
            </div>
            <div>{createTable()}</div>
          </div>
          {(tab === VideoType.PRODUCT_SHORT ||
            tab === VideoType.PRODUCT_LONG) && (
            <FastclickDescription userInfo={userInfo} />
          )}

          <div className="">
            {' '}
            <VideoGuideList videoType={tab} />
          </div>
          <div className="flex justify-center">
            <GuideToUse />
          </div>
          <AuthSaveLinkModal
            linkSaveModal={linkSaveModal}
            setLinkSaveModal={setLinkSaveModal}
            t={t}
          />
          <RevenueModal
            showRevenueModal={showRevenueModal}
            setShowRevenueModal={setShowRevenueModal}
            t={t}
          />
          <FailInfoModal
            failInfoModal={failInfoModal}
            setFailInfoModal={setFailInfoModal}
            errorText={errorText}
          />
          {isPlanPriceModal && (
            <PlanPriceModal
              isPlanPriceModal={isPlanPriceModal}
              setPlanPriceModal={setPlanPriceModal}
              userInfo={userInfo}
            />
          )}
        </div>
      </div>
    </>
  )
}

const AuthSaveLinkModal = (props: any) => {
  const { linkSaveModal, setLinkSaveModal, t } = props

  const [challenge, setChallenge] = useState<ChallengeType | null>(null)
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      link: '',
    },
  })
  const [text, setText] = useState<string>('저장')
  const { data, isPending: getChallengePending, refetch } = useGetChallenge()
  const { mutate: updateMutate, isPending: updatePending } =
    useUpdateChallenge()
  const { mutate: createMutate, isPending: createPending } =
    useCreateChallenge()
  const handleCreateChallenge = (data: any) => {
    const { link } = data
    if (challenge) {
      updateMutate(
        { link, id: challenge.id },
        {
          onSuccess: () => {
            setText(t('videoUsageHistory.modals.challengeParticipation.saved'))
            refetch()
          },
          onError: () => {
            console.log('challenge 업데이트 실패')
          },
        }
      )
    } else {
      createMutate(data, {
        onSuccess: () => {
          setText(t('videoUsageHistory.modals.challengeParticipation.saved'))
          refetch()
        },
        onError: () => {
          console.log('challenge 생성 실패')
        },
      })
    }
  }

  useEffect(() => {
    if (data) {
      setChallenge(data)
      setText(t('videoUsageHistory.modals.challengeParticipation.saved'))
      setValue('link', data.link)
    }
  }, [data, linkSaveModal])

  return (
    <>
      {' '}
      {linkSaveModal && (
        <Modal isModal={linkSaveModal}>
          <form
            onSubmit={handleSubmit(handleCreateChallenge, (err) => {
              console.log(err)
            })}
          >
            <div className="bg-white w-[330px] px-5 pt-8 border-t rounded-t-[20px] flex flex-col gap-6 overflow-auto h-[350px] ">
              <div className="flex flex-col gap-6">
                <p className="font-bold text-[18px]">
                  {t('videoUsageHistory.modals.challengeParticipation.title')}
                </p>
                <div>
                  <p className="text-left">
                    {t(
                      'videoUsageHistory.modals.challengeParticipation.description1'
                    )}
                  </p>
                  <p className="text-left text-error">
                    {t(
                      'videoUsageHistory.modals.challengeParticipation.description2'
                    )}
                  </p>
                </div>
              </div>
              <div className="h-auto pb-8">
                <div className=" relative">
                  <Controller
                    render={({ field: { onBlur, value, ...field } }) => (
                      <>
                        <TextAreaMyVideo
                          value={value}
                          {...field}
                          placeholder={t(
                            'videoUsageHistory.modals.challengeParticipation.placeholder'
                          )}
                          className={classNames('bg-[#F6F8FB]', {
                            'text-[#8F929B]': text === '저장됨',
                          })}
                          disabled={createPending || text === '저장됨'}
                        />
                      </>
                    )}
                    name={'link'}
                    rules={{
                      required: {
                        value: true,
                        message: t(
                          'videoUsageHistory.modals.challengeParticipation.linkRequired'
                        ),
                      },
                    }}
                    control={control}
                  />
                  <div className="flex gap-[16px] absolute right-2 -bottom-14 top-0 items-center ">
                    <button
                      type="button"
                      onClick={() => {
                        setValue('link', '')
                        setText(
                          t(
                            'videoUsageHistory.modals.challengeParticipation.apply'
                          )
                        )
                      }}
                      disabled={createPending}
                    >
                      <img
                        className="w-[32x] h-[32px]"
                        src="assets/img/icon_circle_x.png"
                        alt="x"
                      />
                    </button>
                    <button
                      className={classNames(
                        'bg-[#6B8ACB] hover:bg-[#8FABE5]  text-white   w-[76px] h-[43px]   flex items-center justify-center rounded-[10px] font-bold disabled:opacity-[0.3]',
                        {
                          'active:scale-95': text === '적용',
                        }
                      )}
                      disabled={createPending || text === '저장됨'}
                    >
                      {text}
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <img src="assets/img/challenge/3step.png" alt="" />
              </div>
            </div>
            <div className="w-[330px] text-[14px]  h-[60px]  flex justify-center items-center font-bold">
              <button
                className=" w-[50%] h-full text-black bg-[#EEF1F7] rounded-bl-[20px] border-b border-[#EEF1F7] "
                onClick={() => {
                  setLinkSaveModal(false)
                }}
                disabled={createPending}
                type="button"
              >
                {t('videoUsageHistory.modals.challengeParticipation.cancel')}
              </button>
              <button
                className="text-white w-[50%] h-full bg-main rounded-br-[20px] border-b border-main"
                onClick={() => {
                  setLinkSaveModal(false)
                }}
                disabled={createPending}
                type="button"
              >
                {t('videoUsageHistory.modals.challengeParticipation.confirm')}
              </button>
            </div>
          </form>
        </Modal>
      )}
    </>
  )
}

const FailInfoModal = (props: any) => {
  const { failInfoModal, setFailInfoModal, errorText } = props
  const { t } = useTranslation()

  return (
    <>
      {' '}
      {failInfoModal && (
        <Modal isModal={failInfoModal}>
          <div className="bg-white w-[400px] h-[230px] p-[20px] border-t rounded-t-[20px]">
            <div className="flex flex-col items-center justify-center h-full gap-[24px]">
              <p className="font-bold text-[18px]">{errorText.title}</p>
              <div className="flex flex-col leading-[22px]">
                <p className=" text-[14px] ">{errorText.subtitle}</p>
              </div>
            </div>
          </div>
          <div className="w-[400px] text-[14px]  h-[60px]  flex justify-center items-center">
            <button
              className="text-white w-[100%] h-full bg-main rounded-b-[20px] border-b border-main font-bold"
              onClick={() => {
                setFailInfoModal((prev: any) => !prev)
              }}
            >
              {t('videoUsageHistory.modals.failInfo.confirm')}
            </button>
          </div>
        </Modal>
      )}
    </>
  )
}

const RevenueModal = (props: any) => {
  const { t } = props
  const [challenge, setChallenge] = useState<ChallengeType | null>(null)
  const [text, setText] = useState<string>('저장')
  const [day, setDay] = useState<number>(new Date().getDate())
  const [isOpenDay, setOpenDay] = useState<boolean>(false)

  const { mutate: updateMutate, isPending: updatePending } =
    useUpdateChallenge()
  const { mutate: createMutate, isPending: createPending } =
    useCreateChallenge()
  const handleCreateChallenge = () => {
    const link = watch('link')
    if (challenge) {
      updateMutate(
        { link, id: challenge.id },
        {
          onSuccess: () => {
            setText(t('videoUsageHistory.modals.challengeParticipation.saved'))
            refetch()
          },
          onError: () => {
            console.log('challenge 업데이트 실패')
          },
        }
      )
    } else {
      createMutate(data, {
        onSuccess: () => {
          setText(t('videoUsageHistory.modals.challengeParticipation.saved'))
          refetch()
        },
        onError: () => {
          console.log('challenge 생성 실패')
        },
      })
    }
  }

  const { showRevenueModal, setShowRevenueModal } = props

  const [textList, setTextList] = useState(new Array(18).fill('적용'))
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      link: '',
      challengeDetail: [
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
      ],
    },
  })
  const { data, isPending: getChallengePending, refetch } = useGetChallenge()

  const { mutate, isPending } = useInsertLinkChallenge()
  const handleUpdateChallengeDetail = (index: number) => {
    if (day === 1 || day === 15) {
    } else {
      // 1, 15일 아니면 안된다고 모달을 띄워야 함
      setOpenDay(true)
      return
    }
    const link = watch(`challengeDetail.${index}.link`)
    const id = watch(`challengeDetail.${index}.id`)

    mutate(
      { challengeDetailId: id, link },
      {
        onSuccess: () => {
          refetch()
          console.log('challenge detail 업데이트 성공')
        },
        onError: () => {
          console.log('challenge detail 업데이트 실패')
        },
      }
    )
  }
  const handleTextList = (index: number) => {
    const updateTextList = textList.map((el, i) =>
      i === index ? '적용' : textList[i]
    )

    setTextList(updateTextList)
  }

  useEffect(() => {
    if (data) {
      setChallenge(data)
      setValue('link', data.link)
      setText(t('videoUsageHistory.modals.challengeParticipation.saved'))
      data.challengeDetail.forEach((el, index) => {
        if (el.link) {
          const updateList = textList
          updateList[index] = '저장됨'

          setTextList(updateList)
        }
        setValue(`challengeDetail.${index}.link`, el.link)
        setValue(`challengeDetail.${index}.id`, el.id)
      })
    }
  }, [data, showRevenueModal])

  return (
    <>
      {' '}
      {showRevenueModal && (
        <Modal isModal={showRevenueModal}>
          <div className="bg-white w-[330px] px-5 pt-8 border-t rounded-t-[20px] flex flex-col gap-4 md:max-h-[600px] max-h-[600px]  overflow-y-scroll ">
            <div className="flex flex-col gap-6">
              <p className="font-bold text-[18px]">
                {t('videoUsageHistory.modals.revenueVerification.title')}
              </p>
              <div>
                <p className="text-left ">
                  {t(
                    'videoUsageHistory.modals.revenueVerification.description1'
                  )}
                </p>
                <p className="text-left text-error">
                  {t(
                    'videoUsageHistory.modals.revenueVerification.description2'
                  )}
                </p>

                <div className="flex flex-col items-start bg-[#2E343D] p-[10px] rounded-[10px] mt-2">
                  {' '}
                  <p className="text-main font-bold">
                    {t(
                      'videoUsageHistory.modals.revenueVerification.ruleTitle'
                    )}
                  </p>
                  <ul className=" list-disc flex flex-col items-start text-white ml-6">
                    <li>
                      {t('videoUsageHistory.modals.revenueVerification.rule1')}
                    </li>
                    <li className="text-error">
                      {t('videoUsageHistory.modals.revenueVerification.rule2')}
                    </li>
                    <li>
                      {t('videoUsageHistory.modals.revenueVerification.rule3')}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="h-auto  flex flex-col gap-6">
              {challenge?.challengeDetail.map((el, index) => {
                return (
                  <div className="flex flex-col items-start relative gap-2">
                    <p>
                      {' '}
                      <span className="font-bold">인증 {index + 1}</span>{' '}
                      <span>(1일, 15일 작성/저장만 유효)</span>
                    </p>

                    <Controller
                      render={({ field: { onBlur, value, ...field } }) => (
                        <>
                          <TextAreaMyVideo
                            value={value}
                            {...field}
                            placeholder="수익인증 한 블로그나 유튜브 링크 입력 해당 라운드 1일, 15일 작성/저장만 유효"
                            className={classNames('bg-[#F6F8FB]', {
                              'text-[#8F929B]': textList[index] === '저장됨',
                            })}
                            disabled={isPending || textList[index] === '저장됨'}
                          />
                        </>
                      )}
                      name={`challengeDetail.${index}.link`}
                      control={control}
                    />
                    <div className="flex gap-[16px] absolute right-2 -bottom-24 top-0 items-center ">
                      <button
                        type="button"
                        onClick={() => {
                          setValue(`challengeDetail.${index}.link`, '')
                          handleTextList(index)
                        }}
                        disabled={isPending}
                      >
                        <img
                          className="w-[32x] h-[32px]"
                          src="assets/img/icon_circle_x.png"
                          alt="x"
                        />
                      </button>
                      <button
                        className={classNames(
                          'bg-[#6B8ACB] hover:bg-[#8FABE5] text-white  w-[74px] h-[43px]   flex items-center justify-center rounded-[10px] font-bold disabled:opacity-[0.3]',
                          {
                            ' active:scale-95': textList[index] === '적용',
                          }
                        )}
                        disabled={isPending || textList[index] === '저장됨'}
                        onClick={() => {
                          handleUpdateChallengeDetail(index)
                        }}
                      >
                        {textList[index]}
                      </button>
                    </div>
                  </div>
                )
              })}

              {/* 참여 선언 */}
              <div className=" relative flex flex-col">
                <span className="font-bold text-left mb-1">
                  챌린지 참여 선언
                </span>
                <Controller
                  render={({ field: { onBlur, value, ...field } }) => (
                    <>
                      <TextAreaMyVideo
                        value={value}
                        {...field}
                        placeholder="참여선언 한 블로그나 유튜브 링크 입력"
                        className={classNames('bg-[#F6F8FB]', {
                          'text-[#8F929B]': text === '저장됨',
                        })}
                        disabled={createPending || text === '저장됨'}
                      />
                    </>
                  )}
                  name={'link'}
                  rules={{
                    required: {
                      value: true,
                      message: 'Link 입력은 필수입니다!',
                    },
                  }}
                  control={control}
                />
                <div className="flex gap-[16px] absolute right-2 -bottom-14 top-0 items-center ">
                  <button
                    type="button"
                    onClick={() => {
                      setValue('link', '')
                      setText(
                        t(
                          'videoUsageHistory.modals.challengeParticipation.apply'
                        )
                      )
                    }}
                    disabled={createPending}
                  >
                    <img
                      className="w-[32x] h-[32px]"
                      src="assets/img/icon_circle_x.png"
                      alt="x"
                    />
                  </button>
                  <button
                    className={classNames(
                      'bg-[#6B8ACB] hover:bg-[#8FABE5]  text-white   w-[76px] h-[43px]   flex items-center justify-center rounded-[10px] font-bold disabled:opacity-[0.3]',
                      {
                        'active:scale-95': text === '적용',
                      }
                    )}
                    disabled={createPending || text === '저장됨'}
                    onClick={handleCreateChallenge}
                  >
                    {text}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="w-[330px] text-[14px]  h-[60px]  flex justify-center items-center font-bold">
            <button
              className=" w-[50%] h-full text-black bg-[#EEF1F7] rounded-bl-[20px] border-b border-[#EEF1F7] "
              onClick={() => {
                setShowRevenueModal(false)
              }}
              disabled={isPending}
              type="button"
            >
              {t('videoUsageHistory.modals.revenueVerification.cancel')}
            </button>
            <button
              className="text-white w-[50%] h-full bg-main rounded-br-[20px] border-b border-main font-bold"
              onClick={() => {
                setShowRevenueModal(false)
              }}
              disabled={isPending}
              type="button"
            >
              {t('videoUsageHistory.modals.revenueVerification.confirm')}
            </button>
          </div>
        </Modal>
      )}
      <Modal isModal={isOpenDay}>
        <div className="bg-white w-[335px] px-5 pt-8 border-t rounded-t-[40px] flex flex-col gap-4 md:max-h-[600px] max-h-[600px]  overflow-y-scroll ">
          <div className="flex flex-col gap-4">
            <p className="font-bold text-[18px]">
              🧑‍💻 오늘은 수익 인증일이 아니에요!
            </p>
            <p className="text-[14px] pb-8">
              수익 인증은{' '}
              <span className="text-error font-bold">
                매 월 1일에 한 번, 15일에 한 번<br />
              </span>{' '}
              총 2회 해주세요
            </p>
          </div>
        </div>
        <div className="w-[335px] text-[14px]  h-[60px]  flex justify-center items-center font-bold">
          <button
            className="text-white w-[100%] h-full bg-main rounded-b-[40px] border-b border-main font-bold"
            onClick={() => {
              setOpenDay(false)
            }}
            disabled={isPending}
            type="button"
          >
            확인
          </button>
        </div>
      </Modal>
    </>
  )
}
